<template>
  <div>
    <v-row dense justify="center">
     <v-col sm="3" md="3">
        <v-autocomplete
          :items="section_list"
          v-model="section"
          item-text="name"
          item-value="id"
          label="Employee Section"
          dense
          rounded
          color="#0f2027"
          outlined
          class="ma-2 no-display"
          placeholder="Search by section"
          @change="getEmployeesBySection"
          multiple
          clearable
        ></v-autocomplete>
  </v-col>
  <v-col sm="6" md="6">
    <v-autocomplete
      :items="inst_list"
      v-model="inst_data"
      item-text="name"
      label="Search Employee"
      dense
      return-object
      rounded
      color="#0f2027"
      outlined
      class="ma-2 no-display"
      :loading="comp_load"
      placeholder="Search by employee code or name"
    ></v-autocomplete>
  </v-col>
</v-row>
    <v-row>
      <v-btn class="info" @click="bulk"
      >Proceed to bulk print</v-btn
    >
    </v-row>
    <v-row justify="center" dense v-if="inst_data != null">
      <v-radio-group v-model="radios" mandatory row class="ma-2 no-display">
        <v-radio label="Both" value="both" color="#0f2027"></v-radio>
        <v-radio label="Front Copy" value="front" color="#0f2027"></v-radio>
        <v-radio label="Back Copy" value="back" color="#0f2027"></v-radio>
      </v-radio-group>
      <v-btn @click="icardGenerate()" class="button no-display"
        >Check Icard Data</v-btn
      >
    </v-row>
    <v-row justify="center" dense v-if="inst_data != null">
      <v-btn class="no-display" @click="changeAuth">Change Authority</v-btn>
    </v-row>
    <!-- <v-row dense>
      <v-btn
        v-if="icard_data != ''"
        class="ma-2 no-display"
        tile
        outlined
        color="warning"
        @click="print()"
      >
        <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon>
      </v-btn>
    </v-row> -->

    <v-row dense justify="center">
      <!-- <v-card class="box" v-if="icard_data!=''" flat style="height: 15%; width: 25%;">
                    <v-row>
                        <v-col cols="12" sm="2" md="2">
                     <img :src="icard_data[0].logo" height="100" width="100" alt="logo" /> 
                        </v-col>
                        <v-col cols="12" sm="10" md="10">
                     <span v-html="icard_data[0].heading"> {{icard_data[0].heading}}</span> 
                        </v-col>
                    </v-row>
                    <v-row dense class="black--text" justify="center">
                        <h2>{{icard_data[0].emp_code}}</h2>
                    </v-row>
                    <center><v-img :src="icard_data[0].profile_photo_path" height="50%" width="50%"> </v-img></center>
                       <v-img style="height:130px;width:100%" :src="icard_data[0].watermark">
                            <center>
                            <div class="text-center white--text pt-10 mt-10"><h2>{{icard_data[0].name}}</h2></div>
                            <div class="text-center white--text"><h2>{{icard_data[0].designation}}</h2></div>
                            <div style="position:absolute; bottom:0px;" class="white--text"><strong> Authorised Signatory</strong></div>
                             </center>
                        </v-img>
            </v-card> -->

      <!-- icard data-- <br>{{icard_data}} -->
      <!-- <svg id="barcode2"></svg> -->

      <div
        class="card mr-5"
        v-if="icard_data != '' && radios == 'front'"
        style="width: 25rem"
      >
        <div class="card-body box card-1">
          <v-row dense>
            <!-- <v-col></v-col> -->
            <v-col cols="12" sm="12" md="12">
              <img
                :src="icard_data[0].logo"
                height="100"
                width="100%"
                alt="logo"
              />
            </v-col>
            <!-- <v-col cols="12" sm="10" md="10">
                        <span v-html="icard_data[0].heading"> {{icard_data[0].heading}}</span>
                    </v-col> -->
          </v-row>

          <div>
            <center style="margin-top: -6px">
              <span class="schlname" v-html="icard_data[0].school_name"> </span
              ><br />
              <span class="schladdr">{{ icard_data[0].school_address }}</span
              ><br />
            </center>
          </div>

          <div class="empimg">
            <v-img
              style="background-color: white"
              height="277px"
              :src="icard_data[0].watermark"
            >
              <center>
                <img
                  :src="icard_data[0].profile_photo_path"
                  class="box1"
                  style="width: 60%; height: 160px; margin-top: 28px"
                />
              </center>

              <center>
                <div class="text-center">
                  <h2 style="color: white">{{ icard_data[0].name }}</h2>
                </div>
                <div class="text-center">
                  <h2 style="color: white">{{ icard_data[0].designation }}</h2>
                  <h2 style="color: white">
                    ZPRN:&nbsp;{{ icard_data[0].emp_code }}
                  </h2>
                </div>
                <!-- <h2>{{icard_data[0].emp_code}}</h2> -->
                <!-- <div class="barcoded">
                  <svg id="barcode2"></svg>
                </div> -->
                <!-- <div class="barcoded">
                  <barcode
                    height="20"
                    width="1"
                    v-model="icard_data[0].emp_code"
                    v-bind:value="icard_data[0].emp_code"
                  >
                  </barcode>
                </div> -->
              </center>
            </v-img>
            <v-row dense class="barcoded">
              <center>
                <svg id="barcode2"></svg>
              </center>
            </v-row>
          </div>

          <!-- <v-img height="100%" :src="icard_data[0].watermark">
                   <center>
                        <div class="text-center white--text pt-10 mt-10"><h2>{{icard_data[0].name}}</h2></div>
                        <div class="text-center white--text"><h2>{{icard_data[0].designation}}</h2></div>
                          <div style="position: absolute; bottom: 0px; margin-right: 24%;" class="white--text"><img :src="icard_data[0].sign" style="width:75%;height:60px" alt="logo" /></div>
                          <div style="position: absolute; bottom: 0px; margin-right: 40%; margin-left:-17px" class="white--text"><img :src="icard_data[0].sign" style="width:78%;height:60px" alt="logo" /></div>
                          <div style="position: absolute; bottom: 0px;" class="white--text"><strong> Authorised Signatory</strong></div>
                    </center>
                </v-img> -->
        </div>
      </div>
      <!-- <v-card class="pagebreak box" v-if="icard_data!=''" flat style="height: 15%; width: 25%;"> -->
      <!-- <v-btn v-if="icard_data!=''" class="ma-2 no-display" tile outlined color="warning" @click="print1()"> <v-icon left>mdi-printer</v-icon> Print 1 <v-icon right></v-icon> </v-btn> -->
      <div
        id="print"
        class="card"
        v-if="icard_data != '' && radios == 'back'"
        style="width: 25rem"
      >
        <div class="card-body box card-1">
          <!-- <v-img  :src="icard_data[0].watermark_back"></v-img> -->

          <v-row justify="center">
            <v-col cols="12" sm="12" md="12">
              <!-- <div class="ml-1" style="font-size: 0.83em;height:60px">
                            <strong>Address : </strong>{{icard_data[0].emp_address}}
                        </div> -->
              <div class="ml-3" style="font-size: 0.95em">
                <strong>Address : </strong>{{ icard_data[0].emp_address }}
                <br />
                <strong> Phone : </strong> {{ icard_data[0].emp_contact }}<br />
                <strong> Emergency Contact: </strong>
                {{ icard_data[0].emp_emergency_contact }}<br />
                <strong>D.O.B.: </strong> {{ icard_data[0].emp_dob }}<br />
                <strong>Blood Group: </strong>{{ icard_data[0].emp_blood_group
                }}<br />
                <!-- <strong>Email :- </strong>{{icard_data[0].emp_email}}<br /> -->
                <strong>Joining Date: </strong>{{ icard_data[0].emp_doj }}<br />
                <!-- <strong>Address :- </strong>{{icard_data[0].emp_address}}<br /> -->
              </div>
            </v-col>
          </v-row>
          <strong class="ml-3" style="font-size: 1em">Rules:-</strong>
          <!-- <hr /> -->
          <v-row
            dense
            v-for="(i, index) in icard_data[0].instruction"
            :key="index"
          >
            <!-- <h5>* {{ i.topic }}</h5> -->
            <ul class="inst">
              <li style="padding-left: 0.5em">{{ i.topic }}</li>
            </ul>
          </v-row>
          <!-- <center> <barcode height="20" width="1" v-model="icard_data[0].emp_code" v-bind:value="icard_data[0].emp_code"> </barcode></center> -->
          <!-- <div style=" margin-top: 8px;">
                    
                    <div style=" text-align: end;    margin-top: 28%;">
                       
                        <img class="signature" :src="icard_data[0].sign"  alt="logo" />
                        <strong style=" margin-right: 6px;">Principal</strong>
                      
                    </div>
                </div> -->
          <div style="margin-top: 8px">
            <v-row>
              <v-col cols="12" sm="6" md="6"> </v-col>
              <v-col cols="12" sm="6" md="6" align="right">
                <center>
                  <img
                    :src="icard_data[0].sign"
                    style="width: 58%; height: 60px"
                    alt="logo"
                  /><br />
                  <strong>{{ authority }}</strong>
                </center>
              </v-col>
            </v-row>
          </div>
        </div>
      </div>
      <!-- </v-card> -->
    </v-row>
    <v-row dense justify="center" v-if="icard_data != '' && radios == 'both'">
      <div class="card mr-5" v-if="icard_data != ''" style="width: 25rem">
        <div class="box card-1">
          <v-row dense>
            <v-col cols="12" sm="12" md="12">
              <img
                :src="icard_data[0].logo"
                height="100"
                width="100%"
                alt="logo"
              />
            </v-col>
          </v-row>
          <!-- <div> -->

          <div>
            <center style="margin-top: -6px">
              <span class="schlname" v-html="icard_data[0].school_name"> </span>
              <br />
              <span class="schladdr">{{ icard_data[0].school_address }}</span>
            </center>
          </div>

          <div class="empimg">
            <v-img
              style="background-color: white"
              height="277px"
              :src="icard_data[0].watermark"
            >
              <center>
                <img
                  :src="icard_data[0].profile_photo_path"
                  class="box1"
                  style="width: 60%; height: 160px; margin-top: 28px"
                />
              </center>

              <center>
                <div class="text-center">
                  <h2 style="color: white">{{ icard_data[0].name }}</h2>
                </div>
                <div class="text-center">
                  <h2 style="color: white">
                    {{ icard_data[0].designation }}
                  </h2>
                  <h2 style="color: white">
                    ZPRN:&nbsp;{{ icard_data[0].emp_code }}
                  </h2>
                </div>
                <!-- <h2>{{icard_data[0].emp_code}}</h2> -->

                <!-- <div class="barcoded">
                  <svg id="barcode2"></svg>
                </div> -->

                <!-- <div class="barcoded">
                  <barcode
                    height="20"
                    width="1"
                    v-model="icard_data[0].emp_code"
                    v-bind:value="icard_data[0].emp_code"
                  >
                  </barcode>
                </div> -->
              </center>
            </v-img>
            <v-row dense class="barcoded">
              <center>
                <svg id="barcode2"></svg>
              </center>
            </v-row>
          </div>

          <!-- </div> -->
          <!-- <v-img height="100%" :src="icard_data[0].watermark">
                   <center>
                        <div class="text-center white--text pt-10 mt-10"><h2>{{icard_data[0].name}}</h2></div>
                        <div class="text-center white--text"><h2>{{icard_data[0].designation}}</h2></div>
                          <div style="position: absolute; bottom: 0px; margin-right: 24%;" class="white--text"><img :src="icard_data[0].sign" style="width:75%;height:60px" alt="logo" /></div>
                          <div style="position: absolute; bottom: 0px; margin-right: 40%; margin-left:-17px" class="white--text"><img :src="icard_data[0].sign" style="width:78%;height:60px" alt="logo" /></div>
                          <div style="position: absolute; bottom: 0px;" class="white--text"><strong> Authorised Signatory</strong></div>
                    </center>
                </v-img> -->
        </div>
      </div>

      <!-- <v-card class="pagebreak box" v-if="icard_data!=''" flat style="height: 15%; width: 25%;"> -->
      <!-- <v-btn v-if="icard_data!=''" class="ma-2 no-display" tile outlined color="warning" @click="print1()"> <v-icon left>mdi-printer</v-icon> Print 1 <v-icon right></v-icon> </v-btn> -->
      <div id="print" v-if="icard_data != ''" style="width: 25rem">
        <div class="box card-1">
          <v-img :src="icard_data[0].watermark_back"></v-img>
          <v-row justify="center">
            <v-col cols="12" sm="12" md="12">
              <!-- <div class="ml-1" style="font-size: 0.83em;height:60px">
                            <strong>Address : </strong>{{icard_data[0].emp_address}}
                        </div> -->
              <div class="ml-3" style="font-size: 0.95em">
                <strong>Address : </strong>{{ icard_data[0].emp_address }}
                <br />
                <strong> Phone : </strong> {{ icard_data[0].emp_contact }}<br />
                <strong> Emergency Contact: </strong>
                {{ icard_data[0].emp_emergency_contact }}<br />
                <strong>D.O.B.: </strong> {{ icard_data[0].emp_dob }}<br />
                <strong>Blood Group: </strong>{{ icard_data[0].emp_blood_group
                }}<br />
                <!-- <strong>Email :- </strong>{{icard_data[0].emp_email}}<br /> -->
                <strong>Joining Date: </strong>{{ icard_data[0].emp_doj }}<br />
              </div>
            </v-col>
          </v-row>
          <strong class="ml-3" style="font-size: 1em">Rules:-</strong>
          <!-- <hr /> -->
          <v-row
            dense
            v-for="(i, index) in icard_data[0].instruction"
            :key="index"
          >
            <!-- <h5>*{{ i.topic }}</h5> -->
            <ul class="inst">
              <li style="padding-left: 0.5em">{{ i.topic }}</li>
            </ul>
          </v-row>
          <!-- <center> <barcode height="20" width="1" v-model="icard_data[0].emp_code" v-bind:value="icard_data[0].emp_code"> </barcode></center> -->
          <!-- <div style="background: #0095cb; margin-top: 8px;"> -->
          <!-- <div style=" margin-top: 8px;">

                   
                    <div style=" text-align: end;    margin-top: 28%;">
                       
                        <img class="signature" :src="icard_data[0].sign"  alt="logo" />
                        <strong style="margin-right: 6px;">Principal</strong>
                      
                    </div>
                </div> -->
          <div style="margin-top: 8px">
            <v-row>
              <v-col cols="12" sm="6" md="6"> </v-col>
              <v-col cols="12" sm="6" md="6" align="right">
                <center>
                  <img
                    :src="icard_data[0].sign"
                    style="width: 58%; height: 60px"
                    alt="logo"
                  /><br />
                  <strong>{{ authority }}</strong>
                </center>
              </v-col>
            </v-row>
          </div>
        </div>
      </div>

      <!-- </v-card> -->
    </v-row>
    <v-btn class="info" v-if="inst_data != null" @click="call"
      >Proceed to print</v-btn
    >
  </div>
</template>
<script>
import axios from "axios";
import VueBarcode from "vue-barcode";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  components: {
    barcode: VueBarcode,
  },
  data: () => ({
    comp_load: false,
    inst_list: [],
    radios: null,
    inst_data: null,
    icard_data: [],
    barcodeValue: "",
    authority: "Principal",
    authority_sign: null,
    section_list: [],
    section: [],
    all_inst_list: [],
  }),
  mounted() {
    //  this.barcoded()
    this.comp_load = true;
    this.inst_data = null;
    axios
      .post("/RoleManagement/getAllEmployee")
      .then((res) => {
        if (res.data.msg == "200") {
          this.inst_list = res.data.inst_list;
          this.section_list = [{ id: "all", name: "All" }, ...(res.data.section_list || [])];
           this.all_inst_list = res.data.inst_list;
        } else {
          alert("Somthing went wrong!!!");
        }
      })
      .catch((error) => {
        alert("Somthing went wrong!!!");
      })
      .finally(() => {
        this.comp_load = false;
      });
  },

  updated: function () {
    //console.log("Inside updated");
    this.$nextTick().then(() => {
      if (this.icard_data != "" && this.radios != "back") {
        this.barcoded();
      }
    });
  },
  methods: {
getEmployeesBySection() {
  if (
    !this.section ||
    this.section.length === 0 ||
    this.section.includes("all") 
  ) {
    this.inst_list = this.all_inst_list;
    this.inst_data = null;
    return; 
  }

  this.comp_load = true;
  this.inst_data = null;

  const data = { section_id: this.section };
  axios
    .post("/Payroll/getEmployeesBySection", data)
    .then((res) => {
      if (res.data.flag == "YES") {
        this.inst_list = (res.data.employee_list || [])
          .map((emp) => ({
            instid: emp.instid || emp.id,
            name: emp.name,
          }))
          .filter((emp) => emp.instid != null); 
      } else {
        alert("Something went wrong!!!");
      }
    })
    .catch((error) => {
      alert("Something went wrong!!!");
    })
    .finally(() => {
      this.comp_load = false;
    });
},
    bulk() {
      let routeData = this.$router.resolve({ name: "zeal-inst-bulk-card-print" });
      window.open(routeData.href, "_blank");
    },
    call() {
      localStorage.setItem("inst_data", JSON.stringify(this.inst_data));
      localStorage.setItem("authority", this.authority);
      let routeData = this.$router.resolve({ name: "zeal-inst-card-print" });
      window.open(routeData.href, "_blank");
    },
    changeAuth() {
      this.authority = "Director";
      this.icard_data[0].sign = this.authority_sign;
    },
    // print1(){
    //     window.print();
    // },
    print() {
      this.$store.state.drawer = false;
      let that = this;
      window.onafterprint = function () {
        that.$store.state.drawer = true;
      };
      setTimeout(function () {
        window.print();
      }, 100);
    },

    icardGenerate() {
      const data = {
        inst_data: this.inst_data,
      };
      axios
        .post("/Icard/icardGenerate", data)
        .then((res) => {
          this.authority = "Principal";
          this.icard_data = res.data.icard_data;
          this.authority_sign = res.data.icard_data[0].director_sign;

          this.barcoded();
        })

        .catch((error) => {
          console.log("Error", error);
          alert("Somthing went wrong!!!");
        })
        .finally(() => {
          this.comp_load = false;
        });
    },
    barcoded() {
      // barcode
      console.log("in barcode function");
      var x = this;
      setTimeout(function () {
        JsBarcode("#barcode2", x.icard_data[0].emp_code, {
          // textAlign: "left",
          // height: "46",
          // textPosition: "top",
          font: "cursive",
          fontOptions: "bold",
          // fontSize: 15,
          // textMargin: 3,
          // text: x.icard_data[0].emp_code,
          displayValue: false,
        });
      }, 500);

      /// barcode end
    },
  },
};
</script>
<style scoped>
wrap {
  align-self: flex-end;
}
h2 {
  font-size: 1.2em;
}
tr,
td {
  width: 100%;
}
@media print {
  .pagebreak {
    page-break-before: always;
  }
  header,
  footer,
  nav,
  date {
    display: none !important;
    margin-top: none !important;
  }
  .no-display,
  .v-input__control,
  input[type="button"],
  input[type="submit"],
  input[type="reset"],
  #v-card {
    display: none !important;
    margin-top: none !important;
  }
  v-card {
    border: none !important;
    margin-top: none !important;
  }
  * {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
  .barcoded {
    width: 100% !important;
  }
  @page {
    size: A4;
    margin-top: none !important;
    padding-top: none !important;
    size: 9.5in 9.5in;
    /* size: 11in 15in; */
    /* size: 9.5in 10.5in; */
  }
}
.box1 {
  border: 2px solid black;
}

.box {
  border: 2px solid black;
  height: 35rem;
}
.empimg {
  margin-bottom: 20px;
  margin-top: 8px;
}

.schlname {
  color: #023a9c;
  font-size: large;
  font-weight: bold;
}

.schladdr {
  font-weight: bold;
  font-size: 14px;
}

.schlphone {
  font-weight: bold;
}

.signature {
  width: 38%;
  height: 60px;
  margin-bottom: 13px;
  margin-right: -70px;
}

.barcoded {
  margin-left: 40px;
  margin-top: -7%;
}

#barcode2 {
  /* height: 188px; */
  height: 142px;

  /* width: 100%; */
  width: 65%;
}
.card-1 {
  height: 600px;
}
ul.inst {
  list-style-type: "*";
  font-weight: 500;
  font-size: 14px;
}
</style>
